export default __webpack_public_path__ + "static/media/fullscreen.cd90ff1e.svg";